import { alertModalReducer, configurationReducer, darkModeReducer, loadingModalReducer, mobileModeReducer, userReducer } from '.';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
    reducer: {
        alertModal: alertModalReducer,
        config: configurationReducer,
        darkMode: darkModeReducer,
        loadingModal: loadingModalReducer,
        mobileMode: mobileModeReducer,
        user: userReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
});

export type typeRootState = ReturnType<typeof store.getState>;
